import React, { ReactNode } from 'react';

import { FeatureForEmployersStore } from './for-employers.store';

const ForEmployersContext = React.createContext<FeatureForEmployersStore | null>(null);

export const ForEmployersProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<FeatureForEmployersStore>(() => new FeatureForEmployersStore());

   return <ForEmployersContext.Provider value={store}>{children}</ForEmployersContext.Provider>;
};

export const useForEmployers = () => {
   const ctx = React.useContext(ForEmployersContext);

   if (!ctx) {
      throw new Error('useForEmployers must be used inside ForEmployersProvider');
   }

   return ctx;
};
